import { dateFormat } from "helpers/common";

const AnswerDateRange = ({ answer }) => {
  const dates = answer?.answer?.other_details?.period;
  return (
    <p className="m-0 themeBlue">
      {dates ? (
        <div className="d-flex gap-10">
          <div className="me-2 align-items-center">
            <p className="fw-bold themeBlue m-0">
              <span class="icn me-1" style={{
                color: "rgb(61, 160, 170)"
              }}>■ </span>
              Start Date
            </p>
            <p>{dates[0] ? dateFormat(dates[0], "MM/DD/YYYY") : "--"}</p>
          </div>
          <div className="align-items-center">
            <p className="fw-bold themeBlue m-0">
              <span class="icn me-1" style={{
                color: "rgb(61, 160, 170)"
              }}>■ </span>
              End Date
            </p>
            <p>{dates[1] ? dateFormat(dates[1], "MM/DD/YYYY") : "--"}</p>
          </div>
        </div>
      ):(
        "--"
      )}
    </p>
  )
}

export default AnswerDateRange;